import { isPlainObject } from 'utils/helpers';

export const storeSessionStorage = (key: string, value: string): void => {
    sessionStorage.setItem(key, value);
};

export const getSessionStorage = (key: string, defaultValue: string | null = null): string | null => {
    return sessionStorage.getItem(key) ?? defaultValue;
};

export const getSessionStorageJson = (key: string, defaultValue: {} = {}): {} => {
    const json = getSessionStorage(key);
    try {
        const result = JSON.parse(json);
        if (!isPlainObject(result)) {
            throw new Error();
        }
        return result;
    } catch {
        return defaultValue;
    }
};
